import { render, staticRenderFns } from "./fccPublicacoesTApresentacao.vue?vue&type=template&id=8c5f2a08"
import script from "./fccPublicacoesTApresentacao.vue?vue&type=script&lang=js"
export * from "./fccPublicacoesTApresentacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports